// extracted by mini-css-extract-plugin
export default {"row_ds":"TitleAdmin_row_ds__dQI9N","header_title":"TitleAdmin_header_title__Of-bq","col_ds_12":"TitleAdmin_col_ds_12__YONPP"};